// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://dev-api.peopleflow.sk/',
  openApiUrl: 'https://dev-api.peopleflow.sk/openapi/',
  // apiUrl: 'http://localhost:1212/',
  // openApiUrl: 'http://localhost:1213/openapi/',
  MAX_UPLOAD_SIZE: 20000000, // 20MB for regular attachments
  MAX_COMPANY_LOGO_SIZE: 1000000, // 1MB for profile pictures and company logos
  GAPI_CLIENT_ID: '338496997450-r1gfobd3j6se48osjgdr5ghnt53vitth.apps.googleusercontent.com',
  sentryEnv: 'dev',
  googleMapsApiKey: '__GOOGLE_MAPS_API_KEY__',
};

export const firebaseConfig = {
  apiKey: 'AIzaSyCkrS0kIayaYbssmzMRJyyABkv0eAtB_b8',
  authDomain: 'sameta-dev.firebaseapp.com',
  projectId: 'sameta-dev',
  storageBucket: 'sameta-dev.firebasestorage.app',
  messagingSenderId: '473394391872',
  appId: '1:473394391872:web:5685998b0cff9bb2f9a8a5',
};
